<template>
  <div v-if="isVisible" class="global-loader">
    <div class="global-loader__overlay" :style="overlayStyles">
      <div class="global-loader__content">
        <v-progress-circular
          indeterminate
          :size="loaderSize"
          :color="loaderColor"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const isVisible = computed(() => store.getters.getLoaderVisible);
const loaderSize = computed(() => store.getters.getLoaderSize || 78);
const loaderColor = computed(() => store.getters.getLoaderColor || "#000");
const overlay = computed(() => store.getters.getLoaderOverlay);
const overlayColor = computed(() => store.getters.getLoaderOverlayColor);
const overlayBlur = computed(() => store.getters.getLoaderOverlayBlur);
const overlayStyles = computed(() => ({
  background: overlay.value ? overlayColor.value : "rgba(0,0,0,0)",
  backdropFilter:
    overlay.value && overlayBlur.value !== "0px"
      ? `blur(${overlayBlur.value})`
      : "none",
  WebkitBackdropFilter:
    overlay.value && overlayBlur.value !== "0px"
      ? `blur(${overlayBlur.value})`
      : "none",
}));
</script>

<style scoped>
.global-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.global-loader__overlay {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0);
  display: flex;
  align-items: center;
  justify-content: center;
}

.global-loader__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
</style>
